import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { TransactionEntriesFilteredDocument } from '../../graphql/generated';
import { DateRange } from '../../types';
import { isAllTimeDateRange } from '../../util/dateTime';
import { usePushEventHandler } from '../usePushEventPoller';
import { buildTransactionEntriesFilter } from './buildTransactionEntriesFilter';

export const useCashflowPushEventHandler = ({
    categoryIds,
    accountIds,
    tagNames,
    merchantId,
    dateRange,
    apolloClient,
}: {
    categoryIds: string[] | null;
    accountIds: string[] | null;
    tagNames: string[] | null;
    merchantId: string | null;
    dateRange: DateRange;
    apolloClient: ApolloClient<NormalizedCacheObject>;
}) =>
    usePushEventHandler('cashflow', (pushData) => {
        if (pushData.type === 'TRANSACTION_ENTRIES_UPDATED') {
            const filter = buildTransactionEntriesFilter({
                categoryIds,
                accountIds,
                tagNames,
                merchantId,
                dateRange,
            });

            if (
                isAllTimeDateRange(dateRange) ||
                (pushData.startDate >= dateRange.startDate &&
                    pushData.startDate <= dateRange.endDate) ||
                (pushData.endDate >= dateRange.startDate &&
                    pushData.endDate <= dateRange.endDate)
            ) {
                apolloClient.query({
                    query: TransactionEntriesFilteredDocument,
                    variables: { filter },
                    fetchPolicy: 'network-only',
                });
            }
        }
    });
